import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'

export default {
	namespaced: true,
	state: {
		locations: []
	},
	actions: {
		async loadReservationsList({ state, commit, rootState }, { taxon, accumulatorGroup = null } = { taxon: null }) {
			const result = await service.reservationChannelList({ brand: config.BRAND })
			let fakeId = 0 // TODO: REMOVE THIS, only compatibilty
			// strip down result
			let locations = result.map(v => ({
				code: v.code,
				locationId: v.id || fakeId++,
				reservationUrl: v.reservationUrl,
				name: v.name,
			}))
			commit('setLocations', { item: locations })
		},
	},
	getters: {
		reservationLocations (state) {
			return state.locations
		}
	},
	mutations: {
		setLocations: generateSetChild("locations")
	}
}